import {DestroyRef, inject, Injectable, NgZone} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {LocaleService} from "./locale.service";
import {MenuItem, MenuService} from "../../../backend";
import {PortalEnvironmentService} from "./portal-environment.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root'
})
export class ApplicationMenuService {

  #destroyRef = inject(DestroyRef);
  map = new Map<String, Array<MenuItem>>();


  constructor(
    private localeService: LocaleService,
    private environmentService: PortalEnvironmentService,
    private ngZone: NgZone,
    private menuService: MenuService) {
  }

  findMenuItems(locale: string, portalId: number): Observable<MenuItem[]> {
    if (this.map.has(locale)) {
      return new Observable<MenuItem[]>(observer => {

        observer.next(this.map.get(locale)?? []);
        observer.complete();
        this.ngZone.runOutsideAngular(() => {
        });
      });
    }

    return new Observable<MenuItem[]>(observer => {
      this.menuService.findMenuItems(locale, portalId)
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe(value => {
        this.map.set(locale, value);
        observer.next(value);
        observer.complete();
      })
    });
  }
}
